import {
    Notification,
    UpdateReadStatusRequest,
} from "@ibcos/ui-components/dist/common/models/NotificationTypes";
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export type NotificationsResponse = {
    data: Notification[];
    pageNo: number;
    perPage: number;
    total: number;
    unread: number;
};

export type NotifierKeyResponse = {
    key: string;
};

export const NotificationsApi = createApi({
    reducerPath: "NotificationsApi",
    baseQuery: fetchBaseQuery({
        method: "GET",
        baseUrl: `${import.meta.env.VITE_NOTIFICATIONS_URI}/`,
        credentials: "include",
        prepareHeaders: (headers) => {
            headers.set("X-CSRF", "1");
            return headers;
        },
    }),
    tagTypes: ["Notifications"],
    endpoints: (builder) => ({
        getNotifications: builder.query<NotificationsResponse, void>({
            query: () => `Notifications`,
            providesTags: ["Notifications"],
        }),
        getSearchNotifications: builder.query<
            NotificationsResponse,
            {
                pageNo: number;
                perPage: number;
                types: string;
                status: boolean | "";
            }
        >({
            query: ({ pageNo, perPage, types, status }) =>
                `Notifications/search?pageNo=${pageNo}&perPage=${perPage}&types=${types}&unread=${status}`,
            providesTags: ["Notifications"],
        }),
        putUpdateRead: builder.mutation<void, UpdateReadStatusRequest>({
            query: ({ id, isRead }) => ({
                url: `Notifications/mark-read`,
                method: "PUT",
                body: { id, isRead },
            }),
            invalidatesTags: ["Notifications"],
        }),
        getKey: builder.query<NotifierKeyResponse, void>({
            query: () => `generate-key`,
        }),
    }),
});

export const {
    useGetNotificationsQuery,
    usePutUpdateReadMutation,
    useGetKeyQuery,
} = NotificationsApi;
